import React from "react";
import QrImage from "../Images/Qrimage.jpeg";
import HeroImage from "../Images/1.png";

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="bg-gradient-to-br from-blue-50 to-blue-100 overflow-hidden pt-14 pb-20  md:pb-32"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Hero Content */}
          <div
            className="w-full lg:w-1/2 mb-10 lg:mb-0 lg:pr-12"
            data-aos="fade-right"
          >
            <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Build Your Digital Platform With GeeCom India
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl">
              Frugal, scalable QR-based platforms – designed specifically for
              farmers, rural entrepreneurs, and grassroots innovation.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a
                href="#contact"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-md font-medium text-base md:text-lg transition-colors duration-300 text-center"
              >
                Get Started
              </a>
              <a
                href="#features"
                className="bg-white hover:bg-gray-100 text-blue-600 border border-blue-600 px-8 py-4 rounded-md font-medium text-base md:text-lg transition-colors duration-300 text-center"
              >
                Explore Features
              </a>
            </div>

            {/* Feature Badges */}
            <div className="flex flex-wrap justify-center gap-4 mt-2">
              {[
                "No App / Website",
                "Setup in 24 Hours",
                "QR-Based Solution",
              ].map((text, index) => (
                <div
                  key={index}
                  className="flex items-center bg-white rounded-full px-4 py-2 shadow-sm"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-600 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 
          10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 
          001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-sm font-medium">{text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Image + Floating Elements */}
          <div
            className="w-full lg:w-1/2 relative flex justify-center"
            data-aos="fade-left"
          >
            <div className="relative z-10 rounded-xl overflow-hidden shadow-xl max-w-lg w-full">
              <img
                src={HeroImage}
                onError={(e) =>
                  (e.target.src =
                    "https://placehold.co/800x600?text=GeeCom+India")
                }
                width={600}
                height={600}
                loading="lazy"
                className="w-[600px] h-[400px] object-cover object-center"
                alt="GeeCom Hero"
              />
            </div>

            {/* Floating QR Code Element */}
            <div className="absolute -bottom-8 -left-6 md:-left-14 bg-white p-4 rounded-lg shadow-lg z-20 hidden md:block">
              <img
                src={QrImage}
                alt="QR Code"
                loading="lazy"
                className="w-24 h-24 flex items-center justify-center rounded"
              />

              <p className="text-xs font-medium text-center mt-1 text-black-700 fw-bold">
                Scan to view <br /> Simplicity
              </p>
            </div>

            {/* Floating Feature Badge */}
            <div
              className="absolute top-36 -right-4 md:-right-6 bg-white py-2 px-4 rounded-lg shadow-md z-20 hidden md:flex items-center"
              style={{ border: "1px solid blue" }}
            >
              <span className="flex h-8 w-8 rounded-full bg-blue-100 items-center justify-center mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-blue-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 6v6l4 2m6-2a10 10 0 11-4.93-8.36" />
                </svg>
              </span>
              <span className="text-sm font-medium text-gray-700">
                Go Digital Go Viral
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
